import type { ComponentEnhancer } from 'recompose';
import { useContext } from 'react';

import { RegisterTracking } from '@mindtickle/ui-shell-core/Mixpanel';
import { LocalAuthContext } from '~/components/Auth';

const withMixpanel = <P extends {}>() => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => {
    const { user } = useContext(LocalAuthContext)!;

    return (
      <RegisterTracking user={user}>
        <Component {...props} />
      </RegisterTracking>
    );
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};
export default withMixpanel;
